import { render, staticRenderFns } from "./FilterBrand.vue?vue&type=template&id=0dde1fec&scoped=true&"
import script from "./FilterBrand.vue?vue&type=script&lang=js&"
export * from "./FilterBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dde1fec",
  null
  
)

export default component.exports